import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';

@Component({
  selector: 'app-expert-member-food-card-feedback-awaiting-notification',
  standalone: true,
  imports: [CommonModule, ExpertEventNotificationWrapperComponent],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="식단 피드백 대기 중">
      <div class="text-secondary line-clamp-2">
        {{ notification.notifier.nickname }}님께서 식단 피드백을 기다리고
        있어요.
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertMemberFoodCardFeedbackAwaitingNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true })
  notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'expert-member',
        this.notification.expertMember.id,
      ],
      {
        queryParams: { tab: 'food-card' },
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
